import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

/* eslint-disable */
export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "bgDark",
    themes: {
      bgDark: {
        dark: true,
        colors: {
          primary: "#D4A44C",
          secondary: "#2C1810",
          accent: "#C8956C",
          background: "#0F0F1A",
          surface: "#1A1A2E",
          "surface-variant": "#232340",
          error: "#CF6679",
          success: "#4CAF50",
          warning: "#FB8C00",
          info: "#2196F3",
          "on-primary": "#1A1A2E",
          "on-surface": "#E8E8E8",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      rounded: "lg",
    },
    VCard: {
      rounded: "lg",
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
    },
  },
});
